/**
 * Control-plane route paths more than one file depends on: `./routes.ts`
 * registers them, and a page that links to another route needs the same
 * literal, not a second copy of it to drift from the registration
 * (`../routes/paths.ts` exists at the app level for the identical reason).
 *
 * Relative to the router's `basepath` (`APP_BASEPATH`), like every other route
 * literal in this plane.
 */

import { interpolatePath } from '@tanstack/react-router';

export const CAMPAIGN_ROOT_PATH = '/c/$campaignId';
export const ACCOUNTS_PATH = '/c/$campaignId/accounts';
export const TRACKING_EDITOR_PATH = '/c/$campaignId/accounts/$accountId/tracking';
export const CATALOGUE_PATH = '/t/$tenantId/catalogue';
export const PROFILE_EDITOR_PATH = '/t/$tenantId/catalogue/profiles/$profileId';
/** The Perfil entry's own page with no profile chosen yet: its picker. A static
 *  segment, so it outranks `$profileId` for this one literal. */
export const PROFILE_SELECT_PATH = '/t/$tenantId/catalogue/profiles/perfil';

/** `ACCOUNTS_PATH` filled in, for a caller outside this area that needs a
 *  plain href rather than a typed `<Link>` -- so a page that only knows a
 *  campaign id still derives the URL from the route this file registers,
 *  never a second literal of its own. */
export function accountsPath(campaignId: string): string {
  return interpolatePath({ path: ACCOUNTS_PATH, params: { campaignId } }).interpolatedPath;
}

/** `CATALOGUE_PATH` filled in, for a caller outside this area. */
export function cataloguePath(tenantId: string): string {
  return interpolatePath({ path: CATALOGUE_PATH, params: { tenantId } }).interpolatedPath;
}
